
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.5 15a2.5 2.5 0 10-2.5-2.5V15h2.5zm-7 0a2.5 2.5 0 002.5-2.5v-7a2.5 2.5 0 00-5 0v7a2.5 2.5 0 002.5 2.5z","fill":"#2EB67D"}}),_c('path',{attrs:{"d":"M5.5 17A2.5 2.5 0 108 19.5V17H5.5zm7 0a2.5 2.5 0 00-2.5 2.5v7a2.5 2.5 0 005 0v-7a2.5 2.5 0 00-2.5-2.5z","fill":"#E01E5A"}}),_c('path',{attrs:{"d":"M17 26.5a2.5 2.5 0 102.5-2.5H17v2.5zm0-7a2.5 2.5 0 002.5 2.5h7a2.5 2.5 0 000-5h-7a2.5 2.5 0 00-2.5 2.5z","fill":"#ECB22E"}}),_c('path',{attrs:{"d":"M15 5.5A2.5 2.5 0 1012.5 8H15V5.5zm0 7a2.5 2.5 0 00-2.5-2.5h-7a2.5 2.5 0 000 5h7a2.5 2.5 0 002.5-2.5z","fill":"#36C5F0"}})])
          )
        }
      }
    